import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { cmsApi } from '../constants/constants';
import { oneAssetApi } from '../constants/constants'

@Injectable({
  providedIn: 'root'
})
export class FundriskService {

  constructor(private http: HttpClient) { }


  get_riskLevelByRiskID(riskid) {
    const URL = cmsApi + '/get_riskLevelByRiskID';
    const body = { riskid: riskid };

    return this.http.post(URL, body);
  }

  getFundRiskMapp(fundtype, riskid) {
    const URL = cmsApi + '/getFundRiskMapp';
    const body = {
      fundtype: fundtype,
      riskid: riskid
    };
    return this.http.post(URL, body);
  }

  getTopFund() {
    const URL = cmsApi + '/get_fund_recomend_2';
    const body = {};
    return this.http.post(URL, body);
  }

  getTopFund_all() {
    const URL = cmsApi + '/get_fund_recomend_all_2';
    const body = {};
    return this.http.post(URL, body);
  }

  getFundByType(fundtype) {
    const URL = cmsApi + '/get_fund_recomend_2_by_type';
    const body = { fundtype: fundtype };
    return this.http.post(URL, body);
  }

  GetAssumption() {
    const URL = oneAssetApi + '/Fund/GetAssumption';

    return this.http.get(URL);
  }

}
